import './ccf-analytics-icon.module.scss';

import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfAnalyticsIconProps extends SvgIconProps  {}
/**
 * Component used to display  align center Icon
 * @param props - CcfAcdIconProps
 * @example - <CcfAcdIcon />
 * @returns SVG of align center Icon
 */
export function CcfAnalyticsIcon(props: CcfAnalyticsIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="analytics_icon" data-name="analytics icon">
    <path fill="#00a675"  d="M1.956 1.334h28.088c1.080 0 1.956 0.875 1.956 1.956v25.422c0 1.080-0.875 1.956-1.956 1.956h-28.088c-1.080 0-1.956-0.875-1.956-1.956v-25.422c0-1.080 0.875-1.956 1.956-1.956z"/>
    <path fill="#16d99f"  d="M1.779 1.334h28.266c1.080 0 1.956 0.875 1.956 1.956v0 25.6h-29.244c-0.54 0-0.978-0.438-0.978-0.978v0-26.577z"/>
    <path fill="#daf5fb" opacity="0.15" d="M2.667 28.889h8.858l-9.747-27.555v26.666c0 0.491 0.398 0.889 0.889 0.889v0z"/>
    <path fill="#000" opacity="0.1" d="M24.163 9.358l-7.528 12.588-9.628-8.813-5.229 6.419v3.641l5.811-6.415 9.967 9.058 8.725-16.375-2.118-0.104z"/>
    <path fill="#fff"  d="M0 23.517v-4.005l7.329-8.090 9.172 8.336 5.976-11.216 2.373 1.264-7.6 14.265-9.736-8.849-7.514 8.293z"/>
    <path fill="#fff"  d="M21.32 21.915c0 2.454-1.99 4.444-4.444 4.444s-4.444-1.99-4.444-4.444c0-2.454 1.99-4.444 4.444-4.444s4.444 1.99 4.444 4.444z"/>
    <path fill="#ccc" d="M19.555 21.915c0 1.473-1.194 2.666-2.666 2.666s-2.666-1.194-2.666-2.666c0-1.473 1.194-2.666 2.666-2.666s2.666 1.194 2.666 2.666z"/>
    <path fill="#1ed3a6"  opacity="0.2" d="M7.513 15.224l-2.256 2.49-1.040-2.86 1.366-1.505 1.93 1.874z"/>
    <path fill="#54fcac" opacity="0.2" d="M11.553 15.308l-4.178-4.19 0.093 3.869 2.196 2.203c0.852-0.367 1.519-1.031 1.88-1.859l0.009-0.023z"/>
    <path fill="#7ec81d" opacity="0.2" d="M21.287 16.495l-1.237-3.398 0.765-1.432 4.036-1.858-3.564 6.688z"/>
    <path fill="#fff" d="M10.976 13.323c0 1.963-1.592 3.555-3.555 3.555s-3.555-1.592-3.555-3.555c0-1.963 1.592-3.555 3.555-3.555s3.555 1.592 3.555 3.555z"/>
    <path fill="#ccc" d="M9.199 13.323c0 0.982-0.796 1.778-1.778 1.778s-1.778-0.796-1.778-1.778c0-0.982 0.796-1.778 1.778-1.778s1.778 0.796 1.778 1.778z"/>
    <path fill="#fff" d="M28.998 9.175c0 2.946-2.388 5.334-5.334 5.334s-5.334-2.388-5.334-5.334c0-2.946 2.388-5.334 5.334-5.334s5.334 2.388 5.334 5.334z"/>
    <path fill="#ccc" d="M27.22 9.175c0 1.963-1.592 3.555-3.555 3.555s-3.555-1.592-3.555-3.555c0-1.963 1.592-3.555 3.555-3.555s3.555 1.592 3.555 3.555z"/>
	</g>
    </SvgIcon>
  );
}

export default CcfAnalyticsIcon;
